import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { format, addWeeks, subWeeks, startOfWeek, endOfWeek } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface WeekRange {
  start: Date;
  end: Date;
}

type Props = {
  value: WeekRange;
  onChange: (week: WeekRange) => void;
};

export const WeekPicker = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  const goToPreviousWeek = () => {
    const newStart = subWeeks(value.start, 1);
    onChange({ start: startOfWeek(newStart, { weekStartsOn: 1 }), end: endOfWeek(newStart, { weekStartsOn: 1 }) });
  };

  const goToNextWeek = () => {
    const newStart = addWeeks(value.start, 1);
    onChange({ start: startOfWeek(newStart, { weekStartsOn: 1 }), end: endOfWeek(newStart, { weekStartsOn: 1 }) });
  };

  const goToThisWeek = () => {
    const now = new Date();
    onChange({ start: startOfWeek(now, { weekStartsOn: 1 }), end: endOfWeek(now, { weekStartsOn: 1 }) });
  };

  const dateLabel = `${format(value.start, 'MMM d')} \u2013 ${format(value.end, 'MMM d, yyyy')}`;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ mb: 2 }}>
      <IconButton onClick={goToPreviousWeek} aria-label="previous week">
        <ChevronLeftIcon />
      </IconButton>
      <Typography variant="h6">{dateLabel}</Typography>
      <IconButton onClick={goToNextWeek} aria-label="next week">
        <ChevronRightIcon />
      </IconButton>
      <Button size="small" variant="text" onClick={goToThisWeek}>
        {t('timeClock.approvals.thisWeek')}
      </Button>
    </Stack>
  );
};
